var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePlacholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8702 28.5149L3.8402 28.5449C3.4352 27.6599 3.1802 26.6549 3.0752 25.5449C3.1802 26.6399 3.4652 27.6299 3.8702 28.5149Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5007 15.5697C15.4723 15.5697 17.0707 13.9713 17.0707 11.9997C17.0707 10.028 15.4723 8.42969 13.5007 8.42969C11.529 8.42969 9.93066 10.028 9.93066 11.9997C9.93066 13.9713 11.529 15.5697 13.5007 15.5697Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.285 3H11.715C6.255 3 3 6.255 3 11.715V24.285C3 25.92 3.285 27.345 3.84 28.545C5.13 31.395 7.89 33 11.715 33H24.285C29.745 33 33 29.745 33 24.285V20.85V11.715C33 6.255 29.745 3 24.285 3ZM30.555 18.75C29.385 17.745 27.495 17.745 26.325 18.75L20.085 24.105C18.915 25.11 17.025 25.11 15.855 24.105L15.345 23.685C14.28 22.755 12.585 22.665 11.385 23.475L5.775 27.24C5.445 26.4 5.25 25.425 5.25 24.285V11.715C5.25 7.485 7.485 5.25 11.715 5.25H24.285C28.515 5.25 30.75 7.485 30.75 11.715V18.915L30.555 18.75Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlacholder);
export default __webpack_public_path__ + "static/media/profilePlacholder.832098f3e5d53ef28f028faacc03f427.svg";
export { ForwardRef as ReactComponent };